import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTotalSteps = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19.734,
	height: 17.124,
	viewBox: "0 0 19.734 17.124",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_2678",
		"data-name": "Group 2678",
		transform: "translate(-1725.133 -6545.438)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_212",
				"data-name": "Path 212",
				d: "M150.167,335.736a.8.8,0,0,1,1.448,0l1.052,2.083a5.589,5.589,0,0,0,5,3.112h2.343a.75.75,0,1,0,0-1.5h-.085c-2.063,0-4.046-2.212-5.053-5.636l-1.4-4.765c-.465-1.581-1.429-2.524-2.577-2.524s-2.111.944-2.577,2.524l-1.4,4.765c-1.007,3.424-2.991,5.636-5.053,5.636h-.085a.75.75,0,0,0,0,1.5h2.343a5.589,5.589,0,0,0,5-3.111Zm-2.39,1.408a4.157,4.157,0,0,1-2.058,1.953,11.875,11.875,0,0,0,2.631-4.878l1.4-4.765c.294-1,.784-1.448,1.139-1.448s.844.448,1.139,1.448l1.4,4.765a11.874,11.874,0,0,0,2.631,4.878A4.156,4.156,0,0,1,154,337.144l-1.052-2.083a2.3,2.3,0,0,0-4.124,0Z",
				transform: "translate(1584.109 6218.931)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_213",
				"data-name": "Path 213",
				d: "M186.291,368.2h-2.249a.75.75,0,1,0,0,1.5h2.249a.75.75,0,1,0,0-1.5Z",
				transform: "translate(1557.681 6192.864)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_214",
				"data-name": "Path 214",
				d: "M164.95,368.2h-4.4a.75.75,0,1,0,0,1.5h4.4a.75.75,0,1,0,0-1.5Z",
				transform: "translate(1572.371 6192.864)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_215",
				"data-name": "Path 215",
				d: "M145.049,368.2H142.8a.75.75,0,1,0,0,1.5h2.249a.75.75,0,1,0,0-1.5Z",
				transform: "translate(1583.467 6192.864)",
				fill: "current"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgTotalSteps);
export { ForwardRef as ReactComponent };
